import React from 'react';

import './container.css';

const Container = ({ children }) => <div styleName="contain">{children}</div>;

export default Container;
